import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const TwitterCircle = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 40 40'
    >
      <g fill='none'>
        <rect width='40' height='40' rx='20' fill='white'/>
        <path d='M31.953 12.57C31.0545 12.9656 30.1026 13.2267 29.128 13.345C30.1541 12.7282 30.9224 11.761 31.291 10.622C30.34 11.177 29.286 11.581 28.164 11.806C27.4238 11.0144 26.4429 10.4894 25.3736 10.3125C24.3044 10.1355 23.2067 10.3166 22.2509 10.8276C21.2952 11.3385 20.5349 12.1507 20.0881 13.1381C19.6412 14.1255 19.533 15.2327 19.78 16.288C15.69 16.095 12.067 14.13 9.64 11.162C9.19879 11.9118 8.96866 12.767 8.974 13.637C8.974 15.347 9.844 16.85 11.162 17.733C10.3809 17.7081 9.61697 17.4969 8.934 17.117V17.177C8.93356 18.3134 9.32627 19.4149 10.0455 20.2947C10.7647 21.1745 11.7662 21.7784 12.88 22.004C12.1583 22.1973 11.4024 22.2264 10.668 22.089C10.9841 23.067 11.5977 23.9219 12.423 24.5345C13.2484 25.147 14.2444 25.4867 15.272 25.506C13.5315 26.8719 11.3825 27.6133 9.17 27.611C8.78 27.611 8.391 27.588 8 27.544C10.2557 28.9883 12.8785 29.755 15.557 29.753C24.61 29.753 29.555 22.257 29.555 15.768C29.555 15.558 29.555 15.348 29.54 15.138C30.506 14.4428 31.3392 13.5798 32 12.59L31.953 12.57Z' fill='var(--footer-social-icons-color)'/>
      </g>
    </svg>
  );
});

TwitterCircle.displayName = 'TwitterCircle';
